export default __webpack_public_path__ + "static/media/sculptra.989643e5.pdf";